export default {
  init() {
    var selectedCategory = $('.article-loop').data('cat');
    var page = 1;

    $('#load-more-types').on('click', function () {
      var button = $(this);
      var maxPages = button.data('max-pages');

      console.log(selectedCategory)

      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: {
          action: 'load_more_types',
          page: page,
          category: selectedCategory,
        },
        beforeSend: function () {
          button.text('Loading...').prop('disabled', true);
        },
        success: function (response) {
          $('.article-loop').append(response);
          page++;
          button.text('Load More').prop('disabled', false);

          Foundation.reInit($('[data-equalizer]'));

          if (page > maxPages) {
            button.remove();
          }
        },
      });
    });
  },

  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/taxLwResourceTypes.js